var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#Gear_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.59 12a8 8 0 0 0-.15-1.57l2.09-1.2-2.87-5-2.08 1.2a8.7 8.7 0 0 0-2.72-1.56V1.5H9.14v2.41a8.7 8.7 0 0 0-2.72 1.56l-2.08-1.2-2.87 5 2.09 1.2a8.3 8.3 0 0 0 0 3.14l-2.09 1.2 2.87 5 2.08-1.2a8.7 8.7 0 0 0 2.72 1.56v2.33h5.72v-2.41a8.7 8.7 0 0 0 2.72-1.56l2.08 1.2 2.87-5-2.09-1.2a8 8 0 0 0 .15-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.82a3.82 3.82 0 1 0 0-7.64 3.82 3.82 0 0 0 0 7.64Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Gear_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGear;